import { getTokenSymbol } from '../utils/format';

const symbolToIdMapper = {
  bnb: 'binancecoin',
  wbnb: 'binancecoin',
  matic: 'matic-network',
  cfi: 'cyberfi',
  revo: 'revomon',
  pols: 'polkastarter',
  lss: 'lossless',
  ktn: 'kattana',
};

// coinGeko API require tokenID to get it's price
// in some cases symbol would be different from id (At coingeko prespective)
export const tokenSymbolToId = (token) => {
  const tokenSymbol = getTokenSymbol(token);
  const tokenId = symbolToIdMapper?.[tokenSymbol] || tokenSymbol;
  return tokenId;
};
